import { resetDashboardContextBootstrap } from './context-bootstrap';
import { buildPortalContextErrorUrl } from './portal-local-context';

export const USER_HAS_NO_ACTIVE_SELLERS_IN_SELLER_GROUP =
  'USER_HAS_NO_ACTIVE_SELLERS_IN_SELLER_GROUP';

type ApiError = {
  response?: {
    data?: {
      code?: string;
    };
  };
};

export const isNoActiveSellersInContext = (error: unknown): boolean =>
  (error as ApiError)?.response?.data?.code ===
  USER_HAS_NO_ACTIVE_SELLERS_IN_SELLER_GROUP;

export const redirectNoActiveSellersContextToPortal = (
  portalUrl: string,
  replace: (url: string) => void = (url) => window.location.replace(url),
): void => {
  resetDashboardContextBootstrap();
  replace(buildPortalContextErrorUrl(portalUrl));
};
